import { SIZE_PRESETS, WIDGET_HEIGHT, WIDGET_WIDTH } from "./customization-constants";
import type { SharedWidgetAppearance } from "./customization-types";

type WidthAppearance = Pick<SharedWidgetAppearance, "width">;
type HeightAppearance = Pick<SharedWidgetAppearance, "height">;

export interface ResolvedWidgetWidth {
  width: number;
  isCustomWidth: boolean;
  widthValue: SharedWidgetAppearance["width"];
}

export interface ResolvedWidgetHeight {
  height: number;
  isCustomHeight: boolean;
  heightValue: SharedWidgetAppearance["height"];
}

export function resolveWidgetWidth(appearance: WidthAppearance): ResolvedWidgetWidth {
  const { width } = appearance;

  if (typeof width === "number") {
    return { width, isCustomWidth: true, widthValue: width };
  }

  const preset = SIZE_PRESETS.find((option) => option.value === width);

  return {
    width: preset?.width ?? WIDGET_WIDTH.DEFAULT,
    isCustomWidth: false,
    widthValue: width,
  };
}

export function resolveWidgetHeight(appearance: HeightAppearance): ResolvedWidgetHeight {
  const { height } = appearance;

  if (typeof height === "number") {
    return { height, isCustomHeight: true, heightValue: height };
  }

  const preset = SIZE_PRESETS.find((option) => option.value === height);

  return {
    height: preset?.height ?? WIDGET_HEIGHT.DEFAULT,
    isCustomHeight: false,
    heightValue: height,
  };
}
